import * as actionTypes from '../actions/ActionTypes'
  
export default function(state = [], action) {
  switch (action.type) {
    case actionTypes.UPDATE_ANSWERS: 
      return action.answers 
    default:
      return state
  }
}